
import { Component, Vue } from "vue-property-decorator";
import { modal } from "@/store/modal";
@Component({})
export default class ProtectionOfConfidentialInfoModal extends Vue {
  modal: any = modal;
}
